import { ScwMatSelectRule } from '../../../../shared/component/scw-mat-ui/scw-mat-select/scw-mat-select.model';

export interface ILayoutCardTemplateData {
  id?: number;
  layoutId: number;
  type: LayoutCardTemplateTypeEnum;
  meta: ILayoutWOCardTemplateMetaData;
}

export interface ILayoutWOCardTemplateMetaData {
  textTop: { field: string; isUsedInSelectWorkOrderCard: boolean };
  textMiddle: { field: string; isUsedInSelectWorkOrderCard: boolean };
  textBottom: { field: string; isUsedInSelectWorkOrderCard: boolean };
}

export enum LayoutCardTemplateTypeEnum {
  WORK_ORDER_CARD = 'work_order_card',
  ACTIVITY_CARD = 'activity_card',
  ACTIVITY_BUTTON = 'activity_button',
}

export interface IConfirmedMeta {
  textTop: IWOCardDropdownOptions;
  textMiddle: IWOCardDropdownOptions;
  textBottom: IWOCardDropdownOptions;
}

export interface IWOCardDropdownOptions {
  id: string;
  name: string;
  dummyData: string;
  previewName?: string;
}

export interface IWorkOrderCardEditForm {
  textTop: {
    isEnabled: boolean;
    value: { id: string; name: string }[];
    rules?: ScwMatSelectRule[];
  };
  textMiddle: {
    isEnabled: boolean;
    value: { id: string; name: string }[];
    rules?: ScwMatSelectRule[];
  };
  textBottom: {
    isEnabled: boolean;
    value: { id: string; name: string }[];
    rules?: ScwMatSelectRule[];
  };
}
